// @flow
import React from 'react';
import ReactSelect from 'react-select';

import type { ID_TYPE } from '../../types/common';
// import Input from '../Input';

import styles from './select.css';


type OPTION_TYPE = {
  value: ID_TYPE
};

type SelectPropTypes = {
  size?: string,
  value?: ID_TYPE,
  options: Array<OPTION_TYPE>,
  onChange?: OPTION_TYPE => void
};

type SelectStateTypes = {
  optionValue?: OPTION_TYPE
};

const getOptionValue = (value?: ID_TYPE, options: Array<OPTION_TYPE>) => {
  const result = (options || []).filter(option => option.value === value);
  return result.length > 0 ? result[0] : '';
};

class Select extends React.Component<SelectPropTypes, SelectStateTypes> {
  constructor(props: SelectPropTypes) {
    super(props);

    this.state = {
      optionValue: getOptionValue(props.value, props.options),
    };
  }

  componentWillReceiveProps(nextProps: SelectPropTypes) {
    const { value } = this.props;

    if (value !== nextProps.value) {
      this.setState({
        optionValue: getOptionValue(nextProps.value, nextProps.options),
      });
    }
  }

  render() {
    const {
      size = 'medium',
      onChange,
      ...props
    } = this.props;

    const { optionValue } = this.state;

    return (
      <ReactSelect
        {...props}
        className={
          `
            ${styles.select}
            ${{...styles}}
            ${styles[size] ? styles[size] : ''}
          `
        }
        classNamePrefix="react-select"
        value={optionValue}
        onChange={
          option => onChange && onChange(option.value)
        }
      />
    );
  }
}


export default Select;



// WEBPACK FOOTER //
// ./src/scripts/components/Select/index.jsx